import { parseNumber } from '../../utils/number.utils';
import { ManufacturingOrderNotifications } from '../manufacturing-order-historical-changes';
import { ManufacturingOrderNotificationBuilder } from './manufacturing-order-notification.builder';

export class ManufacturingOrderNotificationsBuilder {
  static fromJson(json) {
    return (json)
      ? new ManufacturingOrderNotifications(
        ManufacturingOrderNotificationBuilder.fromList(json.manufacturingOrderNotifications),
        parseNumber(json.totalPage),
        parseNumber(json.total)
      )
      : null;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/manufacturing-order-notifications.builder.ts